import { typography } from "../tokens/typography";

/**
 * Inject typography tokens as CSS custom properties on the document root
 */
export const injectTypography = () => {
  const root = document.documentElement;

  // Inject font families as CSS variables
  Object.entries(typography.fontFamily).forEach(([key, value]) => {
    const fontFamilyString = Array.isArray(value) ? value.join(", ") : String(value);
    root.style.setProperty(`--font-family-${key}`, fontFamilyString);
  });

  // Inject font sizes as CSS variables
  Object.entries(typography.fontSize).forEach(([key, value]) => {
    root.style.setProperty(`--font-size-${key}`, value);
  });

  // Inject font weights as CSS variables
  Object.entries(typography.fontWeight).forEach(([key, value]) => {
    root.style.setProperty(`--font-weight-${key}`, value.toString());
  });
};
